import { Controller } from "@hotwired/stimulus"

// 회사 위치를 표시하는 간단한 지도 컨트롤러
// 사용법: <div data-controller="map-company" data-map-company-height-value="300px"></div>
export default class extends Controller {
  static values = {
    height: { type: String, default: "300px" }
  }

  // 회사 정보 (산성대로 331)
  static companyInfo = {
    name: "동행돌봄인",
    address: "경기도 성남시 수정구 산성대로 331",
    addressDetail: "11층 1117호",
    lat: 37.4437752,
    lng: 127.1527337,
    // 지도 중심은 마커보다 오른쪽으로 (마커가 왼쪽에 보이도록)
    centerLat: 37.4437752,
    centerLng: 127.1545,
    zoom: 16,
    // 구글 지도 링크
    googleMapsUrl: "https://www.google.com/maps/place/%EB%8F%99%ED%96%89%EB%8F%8C%EB%B4%84%EC%9D%B8/data=!3m1!4b1!4m6!3m5!1s0x357ca9003c6d54bd:0x129d0a041aacdc49!8m2!3d37.4437821!4d127.1527474!16s%2Fg%2F11lzn76hnq?entry=ttu"
  }

  // 한국 범위 제한
  static koreaBounds = {
    north: 39.15157738781489,
    south: 32.753690214482596,
    east: 132.0,
    west: 124.5
  }

  static loadOptions = {
    apiKey: "AIzaSyCRLqccYVyDvpElEqaJNHgg4bsOzwBRUIM",
    version: "quarterly",
    libraries: ["maps", "marker"]
  }

  connect() {
    this.initMap()
  }

  async initMap() {
    const { Loader } = await import("@googlemaps/js-api-loader")
    const google = await new Loader(this.constructor.loadOptions).load()

    const info = this.constructor.companyInfo

    // 지도 컨테이너 생성
    const mapContainer = document.createElement("div")
    mapContainer.style.width = "100%"
    mapContainer.style.height = this.heightValue
    mapContainer.style.borderRadius = "0.5rem"
    this.element.appendChild(mapContainer)

    // 지도 옵션 (POI 라벨 숨김, 리뷰/별점 없음)
    const mapOptions = {
      mapId: 'bc0eaf137b35c23e800ea0ee',
      center: { lat: info.centerLat, lng: info.centerLng },
      zoom: info.zoom,
      restriction: {
        latLngBounds: this.constructor.koreaBounds,
        strictBounds: false
      },
      streetViewControl: false,
      mapTypeControl: false,
      fullscreenControl: true,
      zoomControl: true,
      clickableIcons: false,
      styles: [
        {
          featureType: "poi",
          elementType: "labels",
          stylers: [{ visibility: "off" }]
        },
        {
          featureType: "poi.business",
          stylers: [{ visibility: "off" }]
        }
      ]
    }

    const map = new google.maps.Map(mapContainer, mapOptions)

    // 커스텀 마커 생성
    const markerContent = document.createElement("div")
    markerContent.innerHTML = `
      <div style="
        background: #0fac2e;
        padding: 8px 12px;
        border-radius: 8px;
        box-shadow: 0 2px 6px rgba(0,0,0,0.3);
        display: flex;
        align-items: center;
        gap: 6px;
      ">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="white">
          <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/>
        </svg>
        <span style="color: white; font-weight: bold; font-size: 14px;">동행돌봄인</span>
      </div>
      <div style="
        width: 0;
        height: 0;
        border-left: 10px solid transparent;
        border-right: 10px solid transparent;
        border-top: 10px solid #0fac2e;
        margin: 0 auto;
      "></div>
    `

    const marker = new google.maps.marker.AdvancedMarkerElement({
      position: { lat: info.lat, lng: info.lng },
      map: map,
      title: info.name,
      content: markerContent
    })

    // 정보창 (클릭 시 표시)
    const infoWindow = new google.maps.InfoWindow({
      content: `
        <div style="
          margin-top: 16px;
          padding: 2px 8px 8px 8px;
          min-width: 180px;
        ">
          <h3 style="margin: 0 0 6px 0; color: #0fac2e; font-size: 15px; font-weight: bold;">
            ${info.name}
          </h3>
          <p style="margin: 0 0 2px 0; color: #333; font-size: 13px; line-height: 1.3;">
            ${info.address}
            ${info.addressDetail}
          </p>
          <a href="${info.googleMapsUrl}" target="_blank" rel="noopener noreferrer"
             style="display: inline-flex; align-items: center; gap: 4px; color: #1a73e8; font-size: 12px; text-decoration: none;">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
              <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/>
            </svg>
            Google 지도에서 보기
          </a>
        </div>
      `,
      maxWidth: 220
    })

    // 마커 클릭 시 정보창 토글
    marker.addListener("click", () => {
      infoWindow.open({
        map,
        anchor: marker,
        shouldFocus: false
      })
    })

    // 지도 클릭 시 정보창 닫기
    map.addListener("click", () => {
      infoWindow.close()
    })
  }
}
